import { useOnClickOutside } from 'hooks/use-on-click-outside.hook';
import { useSession } from 'hooks/use-session.hook';
import React, { useRef, useState } from 'react';
import { openModal } from 'services/modal';
import ListChat from '../components/list-chat';
import ModalSetting from '../pages/setting';

export default function Header() {
  const [openListChat, setOpenListChat] = useState<boolean>(false);
  const [hideItemUser, setHideItemUser] = useState<boolean>(true);
  const { userInfo } = useSession();
  const messageChatRef = useRef(null);
  const iUserRef = useRef(null);

  const handleSetting = () => {
    const modal = openModal(ModalSetting);

    modal.afterClosed().subscribe();
  };

  const HandleClickUser = () => {
    setHideItemUser(!hideItemUser);
  };

  useOnClickOutside(messageChatRef, () => setOpenListChat(false));
  useOnClickOutside(iUserRef, () => setHideItemUser(true));

  return (
    <header className='chat-main-header'>
      <div className='header-chat-wrapper'>
        <button className='list-chat-btn' ref={messageChatRef} onClick={() => setOpenListChat(!openListChat)}>
          <i className='fas fa-comment'></i>
          <span className='list-chat-num'>12</span>
        </button>

        <div className='header-info' ref={iUserRef} onClick={HandleClickUser}>
          <div className='info-icon'>
            <div className='info-icon-wrapper'>
              <i className='fas fa-user'></i>
            </div>
          </div>
          <div className='info-name'>
            <p className='info-name-text'>{userInfo?.empName}</p>
          </div>
          <div className={hideItemUser ? 'header-item-chat h-d_none' : 'header-item-chat'}>
            <a className='dropdown-item' role={'button'} onClick={handleSetting}>
              <i className='fas fa-cog'></i> {'Cài đặt'}
            </a>
          </div>
        </div>
      </div>

      {openListChat && <ListChat />}
    </header>
  );
}
